// extracted by mini-css-extract-plugin
module.exports =  {"menu":"iFyw3BfdNXKrTK6OvkOY","menuItem":"FzRlBeY8YzC88ZU8Mr4y","iconMenu":"U7qpwAPvivhguJizODRH","hide":"ZRcggxkvj_nh76wXJ7rW","delete":"iVIeGbNewfMD45gdZGRV"};